









import { Vue, Component, Prop } from 'vue-property-decorator';
import UiProgressBarComponent from '@/app/shared/components/ui/ui-progress-bar-component.vue';
import HotspotQuestionComponent from '@/app/question-plugins/hotspot/hotspot-question-component.vue';

@Component({
  components: {
    UiProgressBarComponent,
    HotspotQuestionComponent
  }
})
export default class DemoComponent extends Vue {

}
